import {
  AfterContentChecked,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { EqBaseComponent } from '../eq-base/eq-base.component';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EqValidator } from '../../interfaces';
import { Subscription } from 'rxjs';
import { EqFormService } from '../eqform.service';

@Component({
  selector: 'eq-time-picker',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatRippleModule,
    MatIconModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './time-picker.component.html',
  styleUrl: './time-picker.component.scss',
})
export class TimePickerComponent implements OnInit, OnDestroy, AfterViewInit {
  hrsPptions = ["00","01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  minPptions = [
    '00',
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "36",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
  ];
  meridianPptions = ['AM', 'PM'];
  hourControl: any = 'hr';
  minControl: any = 'min';
  meridianControl: any = 'meridian';

  controlName: any;
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() appearance: string = '';
  @Input() isDisable: boolean = false;
  @Input() requiredToUpdateChangedValue: boolean = false;
  @Input() form!: FormGroup;
  @Input() validators: EqValidator[] = [];
  @Output() onChange = new EventEmitter<any>();
  @Output('onBlur') onBlur = new EventEmitter<string>();

  pickerForm: FormGroup = new FormGroup({});
  subscription!: Subscription;
  pickerSubscription!: Subscription;
  constructor(private readonly formService: EqFormService) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDisable']) {
      this.isDisable = changes['isDisable']?.currentValue;
      if (this.isDisable) {
        this.form.get(this.name)?.disable();
      } else {
        this.form.get(this.name)?.enable();
      }
    }
    if(changes['requiredToUpdateChangedValue']) {
      const value = this.form.get(this.name)?.value;
      if (value) {
        this.pickerForm.patchValue(value);
      }
    }
  }
  ngOnInit(): void {
    if (!this.form || !this.name) {
      const errMsg: string = !this.form
        ? 'form attribute is missing.'
        : 'name attribute is missing.';
      throw Error(errMsg);
    }
    this.formService.addFormControl(this.pickerForm, 'hour', this.validators);
    this.formService.addFormControl(this.pickerForm, 'minute', this.validators);
    this.formService.addFormControl(
      this.pickerForm,
      'meridian',
      this.validators
    );
    this.formService.addFormControl(this.form, this.name, this.validators);
    this.hourControl = this.pickerForm.controls['hour'];
    this.minControl = this.pickerForm.controls['minute'];
    this.meridianControl = this.pickerForm.controls['meridian'];
    this.controlName = this.form.controls[this.name];

    setTimeout(() => {
      const value = this.form.get(this.name)?.value;
      // console.log(`value ${this.name}????`, value);
      if (value) {
        this.pickerForm.patchValue(value);
        // console.log("pickerForm", this.pickerForm); 
      }else if(!this.validators.length){
        // this.pickerForm.patchValue({
        //   hour: "00",
        //   minute: "00",
        //   meridian: "AM",
        // });
      }
    }, 500);
    this.subscription = this.controlName?.valueChanges?.subscribe(
      (value: any) => {
        this.onChange.emit(value);
      }
    );
    this.pickerSubscription = this.pickerForm.valueChanges.subscribe((res) => {
      if (!this.pickerForm.valid) {
        this.form.controls[this.name]?.setErrors({ required: true });
        // this.form.get(this.name)?.setValue(this.pickerForm.value)
      } else {
        this.form.controls[this.name]?.setErrors(null);
        this.form.get(this.name)?.setValue(this.pickerForm.value);
      }
    });
  }
  ngAfterViewInit(): void {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.pickerSubscription?.unsubscribe();
    this.form.removeControl(this.name);
    this.pickerForm.removeControl('hour');
    this.pickerForm.removeControl('minute');
    this.pickerForm.removeControl('meridian');
  }
  onBlurEvent(e: any) {
    this.onBlur.emit(e.target.value);
  }
  getErrorMessage() {
    return this.formService.getErrorMessage(
      this.pickerForm,
      'hour',
      this.validators
    );
  }
  hasError() {
    return this.formService.hasError(this.form, this.name);
  }
  isValid() {
    return this.formService.isValid(this.form, this.name);
  }

  isOptional() {
    if (this.validators?.length) {
      return false;
    }
    return true;
  }

  isTouched() {
    return this.formService.isTouched(this.form, this.name);
  }

  clearFilter(event: any){
    event.preventDefault()
    this.form.get(this.name)?.reset();
    this.pickerForm.reset();
  }
}
